import { MonitoredOperationListItemResponse } from '@6grain/masofa-monolith-api-client/common/model/monitoredOperationListItemResponse';
import { prettyJson } from '@app/pages/admin/operation-monitoring-page/monitored-output.util';

export type AssignmentResultFilter = 'all' | 'positive';

type OperationListItemWithSnapshot = MonitoredOperationListItemResponse & {
  safeOutputJson?: string | null;
};

export function readAssignmentResultCount(
  item: MonitoredOperationListItemResponse | null | undefined,
): number | null {
  const value = item?.resultCount;
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function formatAssignmentResultTooltip(
  item: MonitoredOperationListItemResponse | null | undefined,
): string | null {
  const raw = (item as OperationListItemWithSnapshot | null | undefined)?.safeOutputJson;
  if (typeof raw !== 'string' || !raw.trim()) {
    return null;
  }
  const formatted = prettyJson(raw, '');
  return formatted.trim() ? formatted : null;
}

export function assignmentResultFilterQuery(filter: AssignmentResultFilter): boolean | undefined {
  return filter === 'positive' ? true : undefined;
}

/** Pending runs and resultCount 0 are hidden by Positive; use after create/copy/Run now. */
export function assignmentResultFilterAfterCreate(): AssignmentResultFilter {
  return 'all';
}
